import { SelectProps } from 'antd';
import { FormProps } from 'antd/lib';
import { useMemo } from 'react';
import { useOutletContext } from 'react-router';

import { PRODUCT_CATALOG_URLS } from '@/constants/urls';
import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';
import { PRODUCT_TYPES } from '@/model/Logistic/PackageItem/ProductTypes';

const useProductCatalogFilter = (formProps: FormProps, filters: any[]) => {
  const { form } = formProps;
  const initialValues: Record<string, any> = useMemo(
    () => {
      const values = Object.fromEntries(
        filters.map(filter => {
          const valueParsed = parseInt(filter.value, 10);
          const value = isNaN(valueParsed) ? filter.value : valueParsed;

          return [filter.field, value];
        }),
      );

      // Valor por defecto para product_type si no viene en los filtros
      if (values.type === undefined) {
        values.product_type = PRODUCT_TYPES.PRODUCT;
      } else {
        values.product_type = values.type;
      }

      return values;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useFormInitialSet(form, initialValues, []);

  const { productCategorySelectProps } = useOutletContext<{
    productCategorySelectProps: SelectProps;
  }>();
  const productCategorySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: productCategorySelectProps,
    resource: PRODUCT_CATALOG_URLS.PRODUCT_CATEGORIES,
    initialValue: initialValues.category,
    labelKey: 'name',
    valueKey: 'id',
  });

  return {
    productCategorySelectProps: productCategorySelectPropsWithInitials,
  };
};

export default useProductCatalogFilter;
